import {Component, OnInit} from '@angular/core';
import {TabViewModule} from "primeng/tabview";
import {AdminMainPageComponent} from "../admin-main-page/admin-main-page.component";
import {AdminTemplateComponent} from "../admin-template/admin-template.component";
import {Setting} from "../../dto/Setting";
import {AdminMenuPageComponent} from "../admin-menu-page/admin-menu-page.component";

@Component({
  selector: 'app-admin-menu-manager',
  standalone: true,
  imports: [
    TabViewModule,
    AdminMainPageComponent,
    AdminMenuPageComponent
  ],
  templateUrl: './admin-menu-manager.component.html',
  styleUrl: './admin-menu-manager.component.css'
})
export class AdminMenuManagerComponent extends AdminTemplateComponent implements OnInit{

  ngOnInit() {
    this.checkLogin();

  }


}
